import React from "react";
import "./PdfModel.css";


const PdfModal = ({ pdfUrl, onClose }) => {
  if (!pdfUrl) return null;

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="pdf-modal-close" onClick={onClose}>✖</button>
        <iframe src={pdfUrl} width="100%" height="650px"></iframe>
      </div>
    </div>
  );
};

export default PdfModal;
